import { render, staticRenderFns } from "./BusinessContactEmail.vue?vue&type=template&id=95c5ef1e"
import script from "./BusinessContactEmail.vue?vue&type=script&lang=js"
export * from "./BusinessContactEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports